export default __webpack_public_path__ + "static/media/appstore-badge.7bf60c47.svg";